export default __webpack_public_path__ + "static/media/Lettucefamily.c5c01962.jpg";